import * as THREE from 'three';
import { offscreen } from './platform.js';
import { staminaDisplay } from './stamina.js';
import { AVATAR_WORLD_SCALE } from './avatarMotion.js';

export function createStaminaVisual() {
  const canvas = offscreen(128, 128), texture = new THREE.CanvasTexture(canvas);
  texture.colorSpace = THREE.SRGBColorSpace;
  const sprite = new THREE.Sprite(new THREE.SpriteMaterial({ map: texture, depthTest: false, depthWrite: false }));
  sprite.scale.setScalar(1.27 * AVATAR_WORLD_SCALE); sprite.renderOrder = 8; sprite.visible = false;
  const right = new THREE.Vector3();
  let lastValue = -1;
  return { sprite, update(value, position, camera) {
    const display = staminaDisplay(value); sprite.visible = display.visible;
    if (!display.visible) return;
    camera.updateMatrixWorld();
    sprite.position.copy(position).addScaledVector(right.setFromMatrixColumn(camera.matrixWorld, 0), 1.025 * AVATAR_WORLD_SCALE);
    sprite.position.y += 1.435 * AVATAR_WORLD_SCALE;
    const rounded = Math.floor(value);
    if (rounded === lastValue) return; lastValue = rounded;
    const ctx = canvas.getContext('2d'); ctx.clearRect(0, 0, 128, 128);
    ctx.lineWidth = 12; ctx.strokeStyle = 'rgba(6,36,32,.65)'; ctx.beginPath(); ctx.arc(64,64,39,0,Math.PI*2); ctx.stroke();
    ctx.lineWidth = 8; ctx.strokeStyle = display.color; ctx.beginPath(); ctx.arc(64,64,39,-Math.PI/2,-Math.PI/2+Math.PI*2*display.ratio); ctx.stroke();
    if(value <= .1) { ctx.fillStyle = '#fff4d3'; ctx.textAlign = 'center'; ctx.font = '500 22px sans-serif';ctx.fillText('稍歇',64,72); }
    texture.needsUpdate = true;
  } };
}
